import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Alert from "./components/Alert";
import useAppStore from "./store";
import {Suspense, lazy, useEffect} from "react";
import Cookie from "./components/Cookie";
import NotFound from "./components/NotFound";

const Home = lazy(() => import("./pages/Home"));
const Test = lazy(() => import("./pages/Test"));
const Paywall = lazy(() => import("./pages/Paywall"));
const Offer = lazy(() => import("./pages/Paywall/Offer"));
const Success = lazy(() => import("./pages/Paywall/Success"));
const Fail = lazy(() => import("./pages/Paywall/Fail"));
const Download = lazy(() => import("./pages/Paywall/Download"));
const Unsubscribe = lazy(() => import("./pages/Subscriptions/Unsubscribe"));
const Reissue = lazy(() => import("./pages/Auth/Reissue"));

declare global {
    interface CSSStyleDeclaration {
        webkitOverflowScrolling?: string;
    }
}

const App = () => {
    const {allowScroll} = useAppStore();

    useEffect(() => {
        if (allowScroll) {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
            document.body.style.webkitOverflowScrolling = "none";
        } else {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
            document.body.style.webkitOverflowScrolling = "";
        }
    }, [allowScroll]);

    return (
        <>
            <BrowserRouter>
                <Suspense>
                    <Routes>
                        <Route path="/" element={<Home />} />

                        <Route path="/paywall" element={<Paywall />} />
                        <Route path="/paywall/offer" element={<Offer />} />
                        <Route path="/paywall/success" element={<Success />} />
                        <Route path="/paywall/download" element={<Download />} />
                        <Route path="/paywall/fail" element={<Fail />} />

                        <Route path="/tests/:type/:id" element={<Test />} />

                        <Route path="/subscriptions/unsubscribe" element={<Unsubscribe />} />
                        <Route path="/auth/reissue" element={<Reissue />} />

                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Suspense>
            </BrowserRouter>

            <Cookie />

            <Alert />
        </>
    );
}

export default App
